<template>
  <div>
    <div class="columns">
      <div class="column">
        <h1 class="title">{{ docName }}</h1>
        <h2 v-if="docDetails" class="subtitle">
          {{ docDetails.Timestamp | prettyDate }}
        </h2>
      </div>
      <div class="column">
        <div class="is-pulled-right">
          <b-button
            icon-right="delete"
            type="is-danger"
            @click="confirmDeletion"
            outlined
            >Löschen</b-button
          >
        </div>
      </div>
    </div>
    <br />
    <template v-if="docDetails">
      <TypeTag
        :isDetail="true"
        :docType="docDetails.InferredDocumentType"
        :isError="docDetails.ExtractedTextDocName == 'ERROR'"
      />
      <br />
    </template>
    <pdf v-if="pdfData" :src="pdfData" />
  </div>
</template>

<script>
import { S3Service } from "@/aws";
import { ApiClient } from "@/api";
import pdf from "vue-pdf";
import TypeTag from "@/components/TypeTag";

const DocumentService = new ApiClient("documents");

export default {
  props: ["docName"],
  components: { pdf, TypeTag },
  data() {
    return {
      docDetails: null,
      pdfData: null
    };
  },
  methods: {
    confirmDeletion() {
      this.$buefy.dialog.confirm({
        title: "Dokument löschen",
        message: `Sind Sie sicher dass Sie <i>${this.docName}</i> löschen wollen? Dies kann nicht rückgängig gemacht werden.`,
        confirmText: "Löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteDocument()
      });
    },
    deleteDocument() {
      DocumentService.delete(this.docName, { data: this.docDetails })
        .then(() => {
          this.$buefy.toast.open({
            message: `${this.docName} wurde erfolgreich gelöscht`,
            type: "is-success"
          });
          this.$router.push({ name: "DocumentList" });
        })
        .catch(error => console.error(error));
    },
    getDocument() {
      DocumentService.get(this.docName).then(
        response => (this.docDetails = response.data)
      );
    },
    getDocumentFile() {
      S3Service.getObject(
        { Key: this.docName, ResponseContentType: "application/pdf" },
        (err, data) => {
          if (err) {
            console.error(err);
          } else {
            this.pdfData = data.Body;
          }
        }
      );
    }
  },
  mounted() {
    this.getDocument();
    this.getDocumentFile();
  }
};
</script>

<style></style>
